/* eslint-disable */
import React, { isValidElement } from "react";
import * as UI from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { ReactReportContext } from "@sa/rep-react";

const useStyles = UI.makeStyles((theme: UI.Theme) =>
  UI.createStyles({
    root: {
      height: "fit-content",
      width: "100%",
    },
    item: {
      height: "fit-content",
      display: "flex",
      width: "100%",
    },
    paper: {
      display: "flex",
      width: "100%",
      overflow: "hidden",
      height: "fit-content",
      flexDirection: "column",
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  }),
);

export const ReportGrid: React.FC<{ current?: string }> = ({ children, current = "default" }) => {
  const context = React.useContext(ReactReportContext);
  const definition = context.reportContext.definition;
  const layouts = definition.layouts;

  const classes = useStyles();
  const theme = useTheme();
  const components = filterLayoutComponents(children, layouts, current);
  return (
    <UI.Grid container spacing={2} className={classes.root} id="dddd">
      {mapLayout({ classes, theme, current, layouts }, components)}
    </UI.Grid>
  );
};

function mapLayout(props: any, children: React.ReactNode[]) {
  const { layouts, current, classes } = props;
  const theme = props.theme as UI.Theme;
  const layout = layouts[current]!;

  return children.map((child) => {
    const elem = child as React.ReactElement;
    const id = elem.props["componentId"]! as string;
    const component = layout.find((x) => x.componentId === id)!;
    const size = component.size as any;
    const height = size.height === "inherit" ? "inherit" : theme.spacing(size.width);
    const minHeight = size.height === "inherit" ? undefined : theme.spacing(size.height);
    const minWidth = !size.width ? undefined : theme.spacing(size.width);
    return (
      <UI.Grid item key={id} xs={size.width} className={classes.item}>
        <UI.Box style={{ minWidth, minHeight, height }} className={classes.paper}>
          {child}
        </UI.Box>
      </UI.Grid>
    );
  });
}

/** Фильтрует компоненты на используемость в отчете по их id */
function filterLayoutComponents(children, layouts, currentLayout) {
  const componentsIdsToRender = layouts[currentLayout].map(({ componentId }) => componentId);
  const componentsToRender: React.ReactNode[] = [];
  React.Children.forEach(children, (child) => {
    if (isValidElement(child)) {
      const { props } = child as React.ReactElement;
      if (props["componentId"] && componentsIdsToRender.includes(props["componentId"].toString())) {
        componentsToRender.push(child);
      }
    }
  });
  return componentsToRender;
}
